import React from 'react';
import { CtaButton } from './CtaButton';
import { media } from '../data/product';
const milestones = [{
  year: 'The problem',
  body: 'A shop owner in Ohio was tired of watching his techs hold a flashlight in their teeth. Every job took longer than it should, and the good work happened in bad light.'
}, {
  year: 'The idea',
  body: 'Put the light where the eyes already are. Not on a strap. Not in a hand. Built into the glasses tradesmen already wear every day.'
}, {
  year: 'The build',
  body: 'Two light sources, three interchangeable lenses, USB-C charging and a frame light enough to forget you have it on. Tested by mechanics, roofers, electricians and drivers before anyone could buy one.'
}, {
  year: 'Today',
  body: 'Over 50,000 X1 are on American jobsites, and every one of them is backed by lifetime free replacement. Break it and we replace it. That is the whole promise.'
}];
export function StorySection() {
  return <section id="story" className="border-b border-white/10 bg-ink-900" data-id="element-904" data-mp="1o7oe8x58mi79">
      <div className="mx-auto max-w-[1400px] px-4 py-14 sm:px-6 lg:px-8 lg:py-20" data-id="element-905" data-mp="1o5lf9nm3xeqe">
        <p className="text-[11px] font-bold uppercase tracking-[0.3em] text-grit-500" data-id="element-906" data-mp="1t698mfxt67ns">Our story</p>
        <div className="mt-4 grid gap-10 lg:grid-cols-[1.05fr_0.95fr] lg:items-center lg:gap-14" data-id="element-907" data-mp="1f6i0gvtz3lhp">
          <div data-id="element-908" data-mp="1k4jhzcbr3cr2">
            <h2 className="grit-headline text-[clamp(2.25rem,8vw,4.5rem)] font-extrabold uppercase text-offwhite" data-id="element-909" data-mp="1k87964tq3n2m">
              We build gear for
              <br data-id="element-910" data-mp="1a86ks4gzygrk" />
              <span className="text-grit-500" data-id="element-911" data-mp="1a8orxw576fe9">the people who build.</span>
            </h2>
            <p className="mt-5 max-w-xl text-lg text-steel-300" data-id="element-912" data-mp="whjr4qq3fh2c">
              GritVue started in a truck bay, not a boardroom. Same grit. Different jobs. A brighter tomorrow.
            </p>

            <ol className="mt-8 max-w-xl" data-id="element-913" data-mp="mjdmi1cwjwts">
              {milestones.map(milestone => <li key={milestone.year} className="border-t border-white/10 py-5" data-id="element-914" data-mp="rhoxwgiuife4">
                  <p className="font-display text-xl font-bold uppercase tracking-wide text-grit-500" data-id="element-915" data-mp="2t74l105vnymp">
                    {milestone.year}
                  </p>
                  <p className="mt-1.5 text-[15px] leading-relaxed text-steel-300" data-id="element-916" data-mp="2odrycvkre1wl">{milestone.body}</p>
                </li>)}
            </ol>

            <div className="mt-8" data-id="element-917" data-mp="2fg989cs9cxdu">
              <CtaButton className="w-full sm:w-auto" data-id="element-918" data-mp="2fh10qeqk6ezw">Get your X1 for $49.95</CtaButton>
              <p className="mt-3 text-sm font-semibold uppercase tracking-wide text-grit-500" data-id="element-919" data-mp="3c4xelbum2w7f">
                3 lenses included · Lifetime free replacement
              </p>
            </div>
          </div>

          <figure data-id="element-920" data-mp="332xw0f3y7k2d">
            <img src={media.tradesSheet} alt="American tradesmen across mechanics, construction, HVAC, plumbing, electrical and trucking wearing the GritVue X1" className="block h-auto w-full border border-white/10" data-id="element-921" data-mp="336ll922d1kba" />
            <figcaption className="mt-3 text-xs font-semibold uppercase tracking-[0.2em] text-steel-500" data-id="element-922" data-mp="1mp7n8v1vw7me">
              Built for what matters
            </figcaption>
          </figure>
        </div>
      </div>
    </section>;
}